import React from 'react';
export function Undo() {
  return <svg width="25" height="11" viewBox="0 0 25 11" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5955 1.23784C9.4407 1.23784 6.58355 2.41641 4.38117 4.33308L0.095459 0.0473633V10.7617H10.8097L6.50022 6.45213C8.15498 5.07117 10.2621 4.21403 12.5955 4.21403C16.8097 4.21403 20.3931 6.96403 21.6431 10.7617L24.4645 9.83308C22.8097 4.84498 18.1312 1.23784 12.5955 1.23784Z" fill="currentColor" />
    </svg>;
}